import { type I18nKey } from 'src/core/common/hooks/useTranslation';

export const scaProcedureErrors: Record<string, I18nKey> = {
  initializationError: 'cards.otpPasswordModal.initializationError',
  unknown: 'cards.otpPasswordModal.unknownError',
  timeout: 'cards.otpPasswordModal.timeoutError',
  rejected: 'cards.otpPasswordModal.rejectedError',
};
